import { render, staticRenderFns } from "./DialogUpdateInfo.vue?vue&type=template&id=71454b34&scoped=true"
import script from "./DialogUpdateInfo.vue?vue&type=script&lang=js"
export * from "./DialogUpdateInfo.vue?vue&type=script&lang=js"
import style0 from "./DialogUpdateInfo.vue?vue&type=style&index=0&id=71454b34&prod&lang=css"
import style1 from "./DialogUpdateInfo.vue?vue&type=style&index=1&id=71454b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71454b34",
  null
  
)

export default component.exports